import axios from "axios"
import { MessageBox, Message } from "element-ui"
import store from "@/store"
import { getToken } from "@/utils/auth"

export const serviceUrl = "/AnnoApi" //本地
//export const serviceUrl = 'http://120.77.87.109/AnnoApi';   //试运行
//export const serviceUrl = 'http://47.115.163.25/AnnoApi';   //测试版
//export const serviceUrl = 'http://113.100.138.211:9938/AnnoApi';   //虚拟机

//export const imgUrl = 'http://113.100.138.211:9940/imgs'; //虚拟机
//export const xmlfileUrl = 'http://113.100.138.211:9940/XML'; //虚拟机
export const imgUrl = "http://120.77.87.109/imgs" //试运行
//export const xmlfileUrl = 'http://120.77.87.109/XML'; //试运行
//export const imgUrl = '/imgs'; //试运行
export const xmlfileUrl = "/XML" //试运行
//export const imgUrl = 'http://47.115.163.25/imgs';  //测试版
//export const xmlfileUrl = 'http://47.115.163.25/XML'; //测试版
//export const imgUrl = 'http://222.169.224.194:5000/imgs';  //测试版
//export const xmlfileUrl = 'http://222.169.224.194:5000/XML'; //测试版

// create an axios instance
const service = axios.create({
  baseURL: serviceUrl, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 20000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent
    config.headers["Content-Type"] = "application/json"
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers["token"] = getToken()
    }
    return config
  },
  (error) => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data

    if (!res.status) {
      Message({
        message: res.msg || "Error",
        type: "error",
        duration: 5 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm("您已退出登录，您可以取消保留此页面，或再次登录", "确定再次登录", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          store.dispatch("user/resetToken").then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject(new Error(res.message || "Error"))
    } else {
      if (JSON.stringify(res.output) === "{}") {
        return res
      }
      return res.output || res
    }
  },
  (error) => {
    console.log("err" + error) // for debug
    Message({
      message: error.message,
      type: "error",
      duration: 10 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
